// Galexia's chat-grade GenUI library — same shape as openuiChatLibrary
// (Card-only root, FollowUpBlock, ListBlock, SectionBlock — chat
// affordances) but with our themed chart wrappers swapped in so inline
// chat charts can use a `palette` arg for color variety. Without this
// swap, the chat side falls back to the bundled charts which hide the
// underlying React `theme` prop — every inline chat chart was rendering
// in the default palette.
//
// Mirrors lib/genui-dashboard-library.ts exactly; both share the same
// themed chart definitions from genui-charts.tsx so a BarChart in chat
// has the same signature as a BarChart in a dashboard.

import { createLibrary } from '@openuidev/react-lang';
import type { Library, ComponentGroup } from '@openuidev/react-lang';
import { openuiChatLibrary, openuiChatPromptOptions } from '@openuidev/react-ui/genui-lib';
import { themedCharts, REPLACED_CHART_NAMES } from './genui-charts';

const baseComponents = Object.values(openuiChatLibrary.components).filter(
  (c) => !REPLACED_CHART_NAMES.has(c.name),
);

const patchedGroups: ComponentGroup[] | undefined = openuiChatLibrary.componentGroups?.map((g) => {
  const overlapsCharts = g.components.some((n) => REPLACED_CHART_NAMES.has(n));
  if (!overlapsCharts) return g;
  const extra =
    "- Each chart accepts an optional last positional arg `palette` (one of: \"ocean\" | \"orchid\" | \"emerald\" | \"sunset\" | \"spectrum\" | \"vivid\"). Vary palettes when there are multiple charts in one reply. For multi-series charts use \"vivid\" (4+ series) or \"spectrum\" / \"sunset\" (2-3 series); single-hue palettes (ocean, emerald, orchid) only have shades of one color and look mono-tonal.";
  return {
    ...g,
    notes: [...(g.notes ?? []), extra],
  };
});

export const galexiaChatLibrary: Library = createLibrary({
  root: openuiChatLibrary.root ?? 'Card',
  componentGroups: patchedGroups,
  components: [...baseComponents, ...themedCharts],
});

export const galexiaChatPromptOptions = openuiChatPromptOptions;
